import { format } from 'date-fns';
import { useState, useEffect } from 'react';

import { cn } from '@/utils/helpers';

interface ClockProps {
  className?: string;
}

export const Clock = ({ className }: ClockProps) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 300);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={cn('flex flex-col items-end', className)}>
      <span className="font-semibold text-sm leading-none tracking-tight">
        {format(now, 'HH:mm:ss')}
      </span>
      <span className="text-xs text-muted-foreground tracking-tight">
        {format(now, 'dd.MM.yyyy')}
      </span>
    </div>
  );
};
